
export default {
  middleware: ['guest']
}
